import React, { CSSProperties } from 'react';

import BrackenIcon from '../images/bracken_icon.svg';
import Grid from '@mui/material/Unstable_Grid2';
import { ReactSVG } from 'react-svg';
import { styled } from '@mui/system';
import styles from '../styles/LoadingIcon.module.css';

interface ILoadingProgress {
  alignLeft?: boolean;
  color?: 'primary' | 'secondary' | 'error' | string;
  size?: number;
  style?: CSSProperties;
}

const StyledDiv = styled('div')<ILoadingProgress>(({ color, size, theme }) => ({
  '& svg': {
    height: size,
    width: size
  },
  '& svg path': {
    fill: theme.palette[color]?.main || color || theme.palette.primary.main
  }
}));

export const CustomLoadingProgress = (props: ILoadingProgress) => {
  const size: number = props.size || 40;

  /** Customize svg parent element styles.
   * This wrapper div is created dynamically for <svg> element.
   * So in order to, override the <div> styles, it is required
   * to find and change styles before injecting to DOM.
   */
  const handleBeforeInjection = (svg: SVGSVGElement | null) => {
    if (svg) {
      setTimeout(() => {
        const wrapperDiv = svg.parentElement;
        if (wrapperDiv) {
          wrapperDiv.style.height = 'inherit';
          wrapperDiv.style.display = 'flex';
        }
      }, 0);
    }
  };

  return (
    <div
      style={{
        ...props.style,
        margin: props.alignLeft ? 'unset' : 'auto',
        width: size,
        height: size
      }}
    >
      <StyledDiv>
        <ReactSVG
          beforeInjection={handleBeforeInjection}
          className={styles.loadingIcon}
          src={BrackenIcon}
          style={{ height: 'inherit' }}
        />
      </StyledDiv>
    </div>
  );
};
